import { render, staticRenderFns } from "./policy-detail.vue?vue&type=template&id=19bb0782&scoped=true&"
import script from "./policy-detail.vue?vue&type=script&lang=ts&"
export * from "./policy-detail.vue?vue&type=script&lang=ts&"
import style0 from "./policy-detail.vue?vue&type=style&index=0&id=19bb0782&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb0782",
  null
  
)

export default component.exports